import React, { useEffect, useState } from 'react';
import { Rate, Icon } from 'antd';
import ReactGA from "react-ga4";
import { UserRating } from '../../services/api';
import { formatAverageRating, roundToHalf } from '../../utils/ratingHelpers';
import { RatingsInfoModal } from '../RatingsInfoModal/RatingsInfoModal';
import styles from './ratingCounter.scss';

interface RatingCounterProps {
  user: {
    id?: string;
    userId?: string;
    username?: string;
    name?: string;
  } & ({ username: string } | { name: string });
  className?: string;
}

const defaultCounts : { totalCount: number; averageRating: number | null } = {
  totalCount: 0,
  averageRating: null,
};

// Rating counter component
const RatingCounter: React.FC<RatingCounterProps> = ({ user, className }) => {
  const [counts, setCounts] = useState(defaultCounts);
  const [modalVisible, setModalVisible] = useState(false);

  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    ReactGA.event({
      category: "Ocjene",
      action: "Click",
      label: "Tooltip za više info"
    });
    setModalVisible(true);
  };

  useEffect(() => {
    const fetchRatingCounts = async () => {
      try {
        const response = await UserRating.getOverallCount(user.id || user.userId);
        setCounts(response);
      } catch (error) {
        console.error('Error fetching rating counts:', error);
        setCounts(defaultCounts);
      }
    };

    if (user && (user.id || user.userId)) {
      fetchRatingCounts();
    }
  }, [user]);

  const hasRatings = counts.averageRating != null && counts.totalCount > 0;

  const getRatingCountText = (count: number) => {
    if (count === 1) return '1 ocjena';
    if (count >= 2 && count <= 4) return `${count} ocjene`;
    return `${count} ocjena`;
  };

  const displayRating = hasRatings ? roundToHalf(counts.averageRating) : 0;

  return (
    <div className={`${styles.ratingCounter} ${hasRatings ? styles.hasRatings : styles.noRatingsState} ${className || ''}`}>
      <div className={styles.starsWrapper}>
        <Rate disabled value={displayRating} allowHalf className={styles.stars} />
        {hasRatings ? (
          <React.Fragment>
            <span className={styles.ratingValue}>{formatAverageRating(counts.averageRating)}</span>
            <span className={styles.count}>({getRatingCountText(counts.totalCount)})</span>
          </React.Fragment>
        ) : (
          <span className={styles.noRatings}>nema ocjena</span>
        )}
      </div>
      <Icon type="info-circle" className={styles.infoIcon} onClick={handleInfoClick} />
      <RatingsInfoModal visible={modalVisible} onCancel={() => setModalVisible(false)} />
    </div>
  );
};

export default RatingCounter;



// WEBPACK FOOTER //
// ./src/components/RatingCounter/index.tsx